import React from 'react'
import Button from '../components/Button'

const CompPopUpWalloven = (props) => {
  return (
    <div className='compZonepopupWalloven'>
      <div className='compPopUpWidthWalloven'>
        <Button
        clickFunction={props.closeRadioPopUpf} 
        classList="closePopup"
        >
        &#10005;
        </Button>

        <div className='popupContent'>
          <p>Walloven is not installed under the counter
          {/* <br></br><br></br>The Under-the-Counter Pedestals in <b>Zone 7</b> is only compatible with <b>SSC2489GS</b> wallOven */}
          </p>
          <Button
          classList="compPopUp"
          clickFunction={props.closeRadioPopUpf}
          >OK</Button>
        </div>

      </div>
    </div>
  )
}

export default CompPopUpWalloven